module.exports = __webpack_public_path__ + "fonts/unicredit-mediumitalic.8aafb53f.woff";